import { Button, Flex, IconFont, Input, Popover, SegmentedControl, SelectDropdown, Text } from '@byecode/ui'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import * as CM from '../styles'
import type { LookType } from '../types'

interface OtherPlatformsProps {
    searchWord: string
    lookType: LookType
    onSearchChange: (value: string) => void
    onLookTypeChange: (v: LookType) => void
}

const SCxContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    flex-shrink: 0;
    min-height: 52px;

    &.pluginStore {
        width: 100%;
        height: 230px;
        background-color: white;
    }

    &.alreadyInstall {
        /* height: ; */
    }

    iconpark-icon {
        color: var(--color-gray-400);
    }
    [data-active] {
        iconpark-icon {
            color: var(--color-theme-7);
        }
    }
`
const SCxSearchContainer = styled.div`
    margin-top: 48px;
    width: 502px;
`

const OPTIONS = [
    {
        label: '已安装',
        value: 'alreadyInstall',
        icon: <IconFont type="WidgetAdd" size={16} />
    },
    {
        label: '插件市场',
        value: 'pluginStore',
        icon: <IconFont type="Compass" size={16} />
    }
]
export const OtherPlatformsHeader: React.FunctionComponent<OtherPlatformsProps> = ({
    searchWord,
    lookType,
    onLookTypeChange,
    onSearchChange
}) => {
    return (
        <SCxContainer className={lookType}>
            <SegmentedControl
                style={{
                    position: 'absolute',
                    left: 22,
                    top: 15
                }}
                size="lg"
                data={OPTIONS}
                value={lookType}
                onChange={onLookTypeChange}
            />
            {lookType === 'pluginStore' && (
                <SCxSearchContainer>
                    <Text style={{ lineHeight: '32px' }} weight={500} align="center" size={24} color="var(--color-gray-700)">
                        ByeCode 插件市场
                    </Text>
                    <Text style={{ lineHeight: '22px', marginTop: 12 }} align="center" size={14} color="var(--color-gray-500)">
                        集成第三方，为您的应用注入丰富的能力
                    </Text>
                    <Input
                        styles={{
                            wrapper: {
                                height: 44,
                                marginTop: 24,
                                borderRadius: 100
                            }
                        }}
                        prefix={<CM.Icon type="SearchLine" color="var(--color-gray-400)" />}
                        value={searchWord}
                        onChange={e => onSearchChange(e.currentTarget.value)}
                        placeholder="搜索，例如“DeepSeek”"
                    />
                </SCxSearchContainer>
            )}

            {lookType === 'alreadyInstall' && (
                <Flex style={{ position: 'absolute', right: 22, top: 15 }} gap={12}>
                    <Input
                        styles={{
                            wrapper: {
                                width: 180
                                // background: 'var(--color-white)',
                            }
                        }}
                        size="lg"
                        prefix={<CM.Icon type="SearchLine" color="var(--color-gray-400)" />}
                        value={searchWord}
                        onChange={e => onSearchChange(e.currentTarget.value)}
                        placeholder="搜索"
                    />
                    <Button size="lg" icon={<CM.Icon type="Add" />} onClick={() => onLookTypeChange('pluginStore')}>
                        去插件市场添加
                    </Button>
                </Flex>
            )}
        </SCxContainer>
    )
}
